"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyEsNotionalGtMaxEs = exports.verifyFuturesOrder = exports.createFutureOrder = exports.validateGtMaxQty = exports.processReduceOnlyFutureUIOrderRequest = exports.processFutureUICustomOrderRequest = exports.processFutureUIOrderRequest = void 0;
const rxjs_1 = require("rxjs");
const errors_1 = require("../../../interface/errors");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const CalculateUtils_1 = require("./CalculateUtils");
const TradeValidate_1 = require("./TradeValidate");
/**生成通用开单参数 */
const processFutureUIOrderRequest = (params) => {
    const { accountType, symbol, orderType, side, price, curPrice, reduceOnly = false, positionMode, investSide, amount, baseInvest, } = params;
    const curPriceD = new trade_utils_lib_1.SafeDecimal(curPrice);
    const limitPriceD = new trade_utils_lib_1.SafeDecimal(price);
    const tradePrice = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? price : curPrice;
    const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(positionMode, reduceOnly, side);
    const request = {
        accountType: accountType,
        type: orderType,
        symbol: symbol.symbol,
        side: side,
        position_side: positionSide,
        confirmed_sensitive: true,
    };
    if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
        if (investSide === interface_1.InvestSymbolSide.base) {
            // 限价投base，用户输入的是base, 传后端是base
            request.amount = amount;
        }
        else {
            // 限价投quote，用户输入的是quote, 传后端是base
            request.amount = baseInvest;
        }
        request.price = tradePrice;
    }
    let status = interface_1.FuturesRequestStatus.Normal;
    if (orderType === interface_1.CustomOrderType.LIMIT) {
        if (side === interface_1.CustomOrderSide.BUY) {
            if (limitPriceD.gt(curPriceD.mul(1.01))) {
                status = interface_1.FuturesRequestStatus.LimitPriceExceed;
            }
        }
        else {
            if (limitPriceD.lt(curPriceD.mul(0.99))) {
                status = interface_1.FuturesRequestStatus.LimitPriceExceed;
            }
        }
    }
    return { request, status };
};
exports.processFutureUIOrderRequest = processFutureUIOrderRequest;
/**生成开单参数 */
const processFutureUICustomOrderRequest = (params, options) => {
    const { orderType, investSide, amount, reduceOnly, baseInvest } = params;
    const { isTwap } = options;
    const { request, status } = (0, exports.processFutureUIOrderRequest)(params);
    if (!CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
        if (reduceOnly) {
            if (!CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
                // 平仓时，直接使用按照比例获取的平仓量
                request.amount = baseInvest;
                request.type = interface_1.CustomOrderType.MARKET_QTY;
            }
        }
        else {
            if (investSide === interface_1.InvestSymbolSide.base) {
                // 市价投base，用户输入的是base, 传后端是base
                request.amount = amount;
            }
            else {
                // 市价投quote，用户输入的是quote, 传后端是quote
                request.spending = amount;
            }
        }
    }
    if (isTwap) {
        Object.assign(request, toTwapOrderRequest(request, investSide, orderType));
    }
    return (0, rxjs_1.of)({
        request,
        status,
        isTwap,
    });
};
exports.processFutureUICustomOrderRequest = processFutureUICustomOrderRequest;
/**生成分批平仓单参数 */
const processReduceOnlyFutureUIOrderRequest = (params) => {
    const { baseInvest, orderType } = params;
    const { request, status } = (0, exports.processFutureUIOrderRequest)(params);
    if (!CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
        // 平仓时，直接使用按照比例获取的平仓量
        request.amount = baseInvest;
        request.type = interface_1.CustomOrderType.MARKET_QTY;
    }
    return (0, rxjs_1.of)({
        request,
        status,
    });
};
exports.processReduceOnlyFutureUIOrderRequest = processReduceOnlyFutureUIOrderRequest;
/**校验用户平仓时数量是否大于单笔最大可开单数量 */
const validateGtMaxQty = (params) => {
    const { orderType, price, symbol, investSide, amount, curPrice, baseInvest } = params;
    // 不支持按本金
    if (investSide === interface_1.InvestSymbolSide.cost) {
        throw new Error("local error: validateGtMaxQty function does not support placing orders by cost.");
    }
    let amountD = new trade_utils_lib_1.SafeDecimal(amount);
    // FIXME: 判断tradePrice是否为空
    const tradePrice = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? price : curPrice;
    const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
    const baseInvestD = new trade_utils_lib_1.SafeDecimal(baseInvest);
    // 判断限价单
    if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
        const max = TradeValidate_1.TradeValidator.getMaxLimitQty(symbol);
        if (baseInvestD.gt(max)) {
            return true;
        }
    }
    else if (CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType)) {
        // 市价单需要同时校验 base 和 quote
        const maxQtyD = TradeValidate_1.TradeValidator.getMaxMarketQty(symbol);
        const maxSpendingD = TradeValidate_1.TradeValidator.getMaxMarketSpending(symbol);
        if (investSide === interface_1.InvestSymbolSide.base) {
            if (baseInvestD.gt(maxQtyD)) {
                return true;
            }
            const toQuote = baseInvestD.mul(tradePriceD);
            if (toQuote.gt(maxSpendingD)) {
                return true;
            }
        }
        else {
            if (amountD.gt(maxSpendingD)) {
                return true;
            }
            const toBase = amountD.div(tradePriceD);
            if (toBase.gt(maxQtyD)) {
                return true;
            }
        }
    }
    return false;
};
exports.validateGtMaxQty = validateGtMaxQty;
/**开单 */
const createFutureOrder = (preRequest, errorInfo) => {
    return (0, exports.verifyFuturesOrder)(preRequest, errorInfo).pipe((0, operators_1.mergeMap)((req) => {
        // 校验平仓单下订单量是否大于单笔交易上限
        if (req.isTwap) {
            return (0, FutureAPI_1.postTwapOrderApi)(req.request);
        }
        return (0, FutureAPI_1.postCustomOrder)(req.request);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.createFutureOrder = createFutureOrder;
/**开单参数校验入口 */
const verifyFuturesOrder = (preRequest, errorInfo) => {
    return (0, rxjs_1.of)(true).pipe((0, operators_1.mergeMap)(() => {
        if (errorInfo) {
            return (0, rxjs_1.throwError)(errorInfo);
        }
        return (0, rxjs_1.of)(true);
    }), (0, operators_1.mergeMap)(() => {
        return verifyCommonRequest(preRequest);
    }), (0, operators_1.mergeMap)((options) => {
        return (0, exports.processFutureUICustomOrderRequest)(preRequest, options);
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
    }));
};
exports.verifyFuturesOrder = verifyFuturesOrder;
const verifyCommonRequest = (params) => {
    var _a;
    const { reduceOnly = false, riskState, available, leverageConfigRow, investSide } = params;
    try {
        verifyBaseParams(params);
        if (!reduceOnly) {
            verifyAvailable(available);
            verifyLeverageConfigRow(leverageConfigRow);
            // 平仓时不校验最大名义价值
            (0, exports.verifyEsNotionalGtMaxEs)({
                esNotional: params.esNotional,
                notionalLimit: (_a = params.leverageConfigRow) === null || _a === void 0 ? void 0 : _a.notional_limit,
                base: params.symbol.baseDisplay,
                quote: params.symbol.quoteDisplay,
                leverage: params.leverage,
            });
        }
        verifyRiskState(riskState);
        verifyCanBuy(params);
        /** 平仓时如果平仓数量大于单笔最大交易，则使用分时委托平仓 */
        const isTwap = reduceOnly && investSide !== interface_1.InvestSymbolSide.cost && (0, exports.validateGtMaxQty)(params);
        verifyQtyLimit(params, { verifyMax: !isTwap });
        verifyLimitPrice(params);
        verifyPostPrice(params);
        return (0, rxjs_1.of)({
            isTwap: isTwap,
        });
    }
    catch (errorInfo) {
        return (0, rxjs_1.throwError)(errorInfo);
    }
};
/**校验基础参数是否完整 */
const verifyBaseParams = (params) => {
    const { orderType, price, curPrice, investSide, amount } = params;
    if (!curPrice) {
        throw errors_1.TRADE_NO_CURRENT_PRICE;
    }
    if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) && new trade_utils_lib_1.SafeDecimal(price).eq(0)) {
        throw errors_1.TRADE_NO_LIMIT_PRICE;
    }
    const amountD = new trade_utils_lib_1.SafeDecimal(amount);
    if (!amount || amountD.eq(0)) {
        if (investSide === interface_1.InvestSymbolSide.quote) {
            throw errors_1.TRADE_NO_VALUE;
        }
        else {
            throw errors_1.TRADE_NO_INVEST;
        }
    }
};
/**校验保证金 */
const verifyAvailable = (available) => {
    if (!available) {
        throw errors_1.TRADE_NO_AVAILABLE;
    }
};
/**校验杠杆信息是否存在 */
const verifyLeverageConfigRow = (leverageConfigRow) => {
    if (!leverageConfigRow) {
        throw errors_1.TRADE_NO_LEVERAGE_ROW;
    }
};
/**校验风险等级 */
const verifyRiskState = (riskState) => {
    if (riskState === interface_1.TraderAccountRiskState.MERGING ||
        riskState === interface_1.TraderAccountRiskState.TAKEOVER ||
        riskState === interface_1.TraderAccountRiskState.LIQUIDATING) {
        throw errors_1.TRADE_DISABLE_OF_LIQUIDATION;
    }
};
/**判断canBuy是否合法 */
const verifyCanBuy = (params) => {
    const { side, investSide, amount, reduceOnly = false, canBuy, positionMode } = params;
    const positionSide = CalculateUtils_1.CalculateUtils.getPositionSide(positionMode, reduceOnly, side);
    const amountD = new trade_utils_lib_1.SafeDecimal(amount);
    if (canBuy) {
        const canBuyD = new trade_utils_lib_1.SafeDecimal(canBuy);
        if (amountD.greaterThan(canBuyD)) {
            // 双向持仓并且是平仓模式
            if (CalculateUtils_1.CalculateUtils.isClosePosition(positionMode, side, positionSide)) {
                throw errors_1.CLOSE_POSITION_MORE_THAN_CAN_BUY;
            }
            else {
                if (investSide === interface_1.InvestSymbolSide.quote) {
                    throw errors_1.TRADE_QUOTE_HIGH_THAN_MAX;
                }
                else {
                    throw errors_1.TRADE_INVEST_MORE_THAN_CAN_BUY;
                }
            }
        }
    }
};
/**校验下单数量是否合法 */
const verifyQtyLimit = (params, options) => {
    const { symbol, orderType, price, curPrice, investSide, amount, reduceOnly = false } = params;
    const { verifyMax = true } = options || {};
    // const baseInvestD = new SafeDecimal(baseInvest);
    const tradePrice = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? price : curPrice;
    const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
    const amountD = new trade_utils_lib_1.SafeDecimal(amount);
    if (tradePrice && Number(tradePrice)) {
        if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType)) {
            if (investSide === interface_1.InvestSymbolSide.base) {
                // 投 base
                const error = TradeValidate_1.TradeValidator.validateLimitQty(amountD, symbol, tradePrice, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
            }
            else {
                // 投quote 转成 base 检测
                const error = TradeValidate_1.TradeValidator.validateLimitSpending(amountD, symbol, tradePrice, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
            }
        }
        else if (CalculateUtils_1.CalculateUtils.isFuturesMarket(orderType)) {
            // 市价单需要同时校验 base 和 quote
            if (investSide === interface_1.InvestSymbolSide.base) {
                let error = TradeValidate_1.TradeValidator.validateMarketQty(amountD, symbol, tradePrice, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
                const toQuote = amountD.mul(tradePriceD);
                error = TradeValidate_1.TradeValidator.validateMarketSpending(toQuote, symbol, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
            }
            else {
                let error = TradeValidate_1.TradeValidator.validateMarketSpending(amountD, symbol, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
                const toBase = amountD.div(tradePriceD);
                error = TradeValidate_1.TradeValidator.validateMarketQty(toBase, symbol, tradePrice, reduceOnly, verifyMax);
                if (error) {
                    throw error;
                }
            }
        }
    }
};
/**判断仅挂单时价格合法 */
const verifyPostPrice = (params) => {
    const { orderType, side, price, curPrice } = params;
    const curPriceD = new trade_utils_lib_1.SafeDecimal(curPrice);
    const limitPriceD = new trade_utils_lib_1.SafeDecimal(price);
    if (orderType === interface_1.CustomOrderType.POST && Number(curPrice)) {
        if (side === interface_1.CustomOrderSide.BUY) {
            // 禁止过高买入
            if (limitPriceD.greaterThan(curPriceD)) {
                throw errors_1.TRADE_LIMIT_POST_PRICE_HIGH;
            }
        }
        else {
            // 禁止过低卖出
            if (limitPriceD.lessThan(curPriceD)) {
                throw errors_1.TRADE_LIMIT_POST_PRICE_LOW;
            }
        }
    }
};
/**判断限价单挂单价格合法 */
const verifyLimitPrice = (params) => {
    var _a;
    const { symbol, orderType, side, price, curPrice, markPrice } = params;
    const tradePrice = CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) ? price : curPrice;
    const tradePriceD = new trade_utils_lib_1.SafeDecimal(tradePrice);
    if (CalculateUtils_1.CalculateUtils.isFuturesLimit(orderType) && ((_a = symbol.originData) === null || _a === void 0 ? void 0 : _a.max_impact_limit)) {
        const checkPrice = markPrice !== null && markPrice !== void 0 ? markPrice : curPrice;
        const checkPriceD = new trade_utils_lib_1.SafeDecimal(checkPrice);
        if (checkPriceD.greaterThan(0)) {
            // 限价单最大冲击价格比率
            const maxImpactLimit = symbol.originData.max_impact_limit;
            if (side === interface_1.CustomOrderSide.BUY) {
                // 禁止过高买入
                const maxPrice = checkPriceD.div(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(maxImpactLimit)));
                if (tradePriceD.greaterThan(maxPrice)) {
                    throw errors_1.TRADE_LIMIT_PRICE_HIGH;
                }
            }
            else {
                // 禁止过低卖出
                const minPrice = checkPriceD.mul(new trade_utils_lib_1.SafeDecimal(1).sub(new trade_utils_lib_1.SafeDecimal(maxImpactLimit)));
                if (tradePriceD.lessThan(minPrice)) {
                    throw errors_1.TRADE_LIMIT_PRICE_LOW;
                }
            }
        }
    }
};
/**交易后仓位价值是否会大于最大名义价值 */
const verifyEsNotionalGtMaxEs = (params) => {
    const { esNotional, notionalLimit, base, quote, leverage } = params;
    if (esNotional && new trade_utils_lib_1.SafeDecimal(esNotional).gt(new trade_utils_lib_1.SafeDecimal(notionalLimit))) {
        throw (0, errors_1.cloneError)(errors_1.TRADE_NOTIONAL_EXCEED, { base: base, quote: quote, leverage, limit: notionalLimit || "--" });
    }
};
exports.verifyEsNotionalGtMaxEs = verifyEsNotionalGtMaxEs;
/**CustomOrderRequest转 twap 开单参数 */
const toTwapOrderRequest = (cRequest, investSide, orderType) => {
    const { symbol, side, type, position_side, price, amount } = cRequest;
    const request = {
        symbol,
        side,
        type,
        position_side,
        price,
    };
    // 判断是否是市价单或者投资类型为 base 时，参数改为 qty
    // 目前无论市价平还是限价平，都是走 base
    request.qty = amount;
    // if (investSide === InvestSymbolSide.base || CalculateUtils.isFuturesMarket(orderType) || CalculateUtils.isFuturesLimit(orderType)) {
    //     request.qty = amount;
    // } else {
    //     request.spending = amount;
    // }
    return request;
};
